import { PermitCategory } from "../common/enums";
import PositionPickerRow from "./forms/Permits/PositionPickerRow";

type Position = {
    id: number;
    isActive: boolean;
    longitude: number;
    latitude: number;
    comment: string | undefined;
    polygonJsonObject: any;
    polygon: any;
    order: number;
    category: PermitCategory | undefined;
};

export default Position;

export function Position_toPositionPickerRow(position: Position): PositionPickerRow {
    let polygon = position.polygonJsonObject ? JSON.parse(position.polygonJsonObject) : undefined;

    if (polygon && polygon.body) {
        //
        // Due to a previous bug, some positions of the GeneralDepartmentPermits have polygons nested under a "body" property.
        // This is a workaround to handle that case. We should correct these positions in the database and remove this section.
        //
        polygon = JSON.parse(polygon.body);
    }

    const row: PositionPickerRow = {
        id: position.id,
        comment: position.comment,
        isActive: position.isActive,
        latitude: position.latitude,
        longitude: position.longitude,
        polygon: polygon,
        order: position.order,
        category: position.category
    };

    return row;
}

export function Position_normalize(position: Position): Position {
    const normalizedPosition: Position = {
        id: position.id,
        comment: position.comment,
        isActive: position.isActive,
        latitude: position.latitude,
        longitude: position.longitude,
        polygonJsonObject: position.polygonJsonObject,
        polygon: position.polygon
            ? position.polygon
            : position.polygonJsonObject
              ? JSON.parse(position.polygonJsonObject)
              : undefined,
        order: position.order,
        category: position.category
    };

    return normalizedPosition;
}
